import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchBarComponent),
      multi: true,
    },
  ],
})
export class SearchBarComponent implements ControlValueAccessor {
  @Input() placeholder = 'Search';
  @Input() ariaLabel?: string;
  @Input() disabled = false;

  /** Optional image icons (if not set, material icons will be used). */
  @Input() prefixImageSrc?: string;
  @Input() clearImageSrc?: string;
  @Input() prefixAlt = '';
  @Input() clearAlt = 'Clear search';

  /** Emits on every user input (useful for debounced searches). */
  @Output() valueInput = new EventEmitter<string>();
  /** Emits after clear button click. */
  @Output() cleared = new EventEmitter<void>();

  value = '';

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: unknown): void {
    this.value = typeof value === 'string' ? value : '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event): void {
    const next = (event.target as HTMLInputElement).value ?? '';
    this.value = next;
    this.onChange(next);
    this.valueInput.emit(next);
  }

  onBlur(): void {
    this.onTouched();
  }

  clear(): void {
    if (this.disabled) {
      return;
    }
    this.value = '';
    this.onChange('');
    this.valueInput.emit('');
    this.cleared.emit();
  }
}

